import { SpeedInsights } from "@vercel/speed-insights/react";
import { useLocation } from "react-router-dom";

export function RoutePerformanceAnalytics() {
  const location = useLocation();
  return location.pathname.startsWith('/tool/') || location.pathname.startsWith('/share/asset/') ? null : <SpeedInsights />;
}
